import { Card, CardContent } from '@/components/ui/card';
import { FormInput, TFormInput } from '@/components/ChatSettings/FormInput';

type Props = {
  title: string;
  blurb: string;
  inputIds: string[];
  allInputs: any[];
  values: Record<string, unknown>;
  setField: (field: string, value: any) => void;
};

export default function WidgetSection({
  title,
  blurb,
  inputIds,
  allInputs,
  values,
  setField
}: Props) {
  const inputs = allInputs.filter((i: any) => inputIds.includes(i.id));

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        <p className="text-xs text-muted-foreground">{blurb}</p>
      </div>
      {inputs.length > 0 ? (
        <Card>
          <CardContent className="p-4 flex flex-col gap-4">
            {inputs.map((input: any) => (
              <FormInput
                key={input.id}
                element={
                  {
                    ...input,
                    value: values[input.id],
                    onChange: () => {},
                    setField
                  } as TFormInput
                }
              />
            ))}
          </CardContent>
        </Card>
      ) : (
        <p className="text-sm text-muted-foreground">
          Nothing configured for this section yet.
        </p>
      )}
    </div>
  );
}
